import type {
  FindReplaceContextType,
  FindReplaceState,
} from "../contexts/FindReplaceContext"

export interface HighlightState {
  shouldHighlight: boolean
  highlightText?: string
  isCurrentMatch: boolean
}

export const getHighlightState = (
  findReplaceState: FindReplaceContextType["findReplaceState"],
  testCaseId: string,
  field: FindReplaceState["matches"][number]["field"],
  fieldKey?: string,
): HighlightState => {
  if (!findReplaceState?.findText) {
    return {
      shouldHighlight: false,
      highlightText: undefined,
      isCurrentMatch: false,
    }
  }

  const matches = findReplaceState.matches
  const hasMatch = matches.some(
    (m) =>
      m.testCaseId === testCaseId &&
      m.field === field &&
      (fieldKey ? m.fieldKey === fieldKey : !m.fieldKey),
  )

  if (!hasMatch) {
    return {
      shouldHighlight: false,
      highlightText: undefined,
      isCurrentMatch: false,
    }
  }

  const currentMatchIndex = findReplaceState.currentMatchIndex
  const isValidIndex =
    currentMatchIndex >= 0 && currentMatchIndex < matches.length
  const currentMatch = isValidIndex ? matches[currentMatchIndex] : undefined

  const isCurrentMatch =
    currentMatch?.testCaseId === testCaseId &&
    currentMatch?.field === field &&
    (fieldKey ? currentMatch?.fieldKey === fieldKey : !currentMatch?.fieldKey)

  return {
    shouldHighlight: true,
    highlightText: findReplaceState.findText,
    isCurrentMatch,
  }
}
